import type { ButtonHTMLAttributes, ReactNode } from "react";

type Size = "sm" | "md";

const sizes: Record<Size, string> = {
  sm: "h-7 w-7",
  md: "h-9 w-9",
};

export default function IconButton({
  children,
  size = "md",
  className = "",
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  size?: Size;
}) {
  return (
    <button
      {...rest}
      className={`inline-flex items-center justify-center rounded text-fg-subtle hover:text-fg hover:bg-surface-2 transition-colors ${sizes[size]} ${className}`}
    >
      {children}
    </button>
  );
}
